import { useState } from "react";
import "./promotions.css";
import PromoView from "./PromoView/PromoView";

const firms = [
  {
    name: "Tehnomanija",
    email: "tehnomanija.com",
    location: "jiansd",
    workFields: [],
    employees: [],
    messages: [],
    presentation: "ajsdas",
    images: [
      "https://www.danas.rs/wp-content/uploads/2021/04/Tehnomanija-isticanje-final.jpg",
      "https://www.bigcenters.rs/zrenjanin/wp-content/uploads/sites/6/2022/05/tehnomanija-zrenjanin-big-zrenjanin-1.jpg",
      "https://scontent.fbeg6-1.fna.fbcdn.net/v/t31.18172-8/12888523_10156684496705290_7800493449242931418_o.jpg?_nc_cat=105&ccb=1-7&_nc_sid=c2f564&_nc_ohc=Ec8o686TpGsAX8f2l65&_nc_ht=scontent.fbeg6-1.fna&oh=00_AfBujI6Rc2hVTdj7jza6FCRWXU9kqk9pZkPJXGBRPnSMCg&oe=659D7526",
      "https://www.danas.rs/wp-content/uploads/2021/04/Tehnomanija-isticanje-final.jpg",
      "https://www.bigcenters.rs/zrenjanin/wp-content/uploads/sites/6/2022/05/tehnomanija-zrenjanin-big-zrenjanin-1.jpg",
      "https://scontent.fbeg6-1.fna.fbcdn.net/v/t31.18172-8/12888523_10156684496705290_7800493449242931418_o.jpg?_nc_cat=105&ccb=1-7&_nc_sid=c2f564&_nc_ohc=Ec8o686TpGsAX8f2l65&_nc_ht=scontent.fbeg6-1.fna&oh=00_AfBujI6Rc2hVTdj7jza6FCRWXU9kqk9pZkPJXGBRPnSMCg&oe=659D7526",
      "https://www.danas.rs/wp-content/uploads/2021/04/Tehnomanija-isticanje-final.jpg",
      "https://www.bigcenters.rs/zrenjanin/wp-content/uploads/sites/6/2022/05/tehnomanija-zrenjanin-big-zrenjanin-1.jpg",
      "https://scontent.fbeg6-1.fna.fbcdn.net/v/t31.18172-8/12888523_10156684496705290_7800493449242931418_o.jpg?_nc_cat=105&ccb=1-7&_nc_sid=c2f564&_nc_ohc=Ec8o686TpGsAX8f2l65&_nc_ht=scontent.fbeg6-1.fna&oh=00_AfBujI6Rc2hVTdj7jza6FCRWXU9kqk9pZkPJXGBRPnSMCg&oe=659D7526",
    ],
    phone: "1881412",
    folder: [],
    checkedAttributes: ["name", "email", "images"],
  },
  {
    name: "Forma ideale",
    email: "formaideale.com",
    location: "jiansd",
    workFields: [],
    employees: [],
    messages: [],
    presentation: "ajsdas",
    images: [],
    phone: "1881412",
    folder: [],
    checkedAttributes: ["name", "email", "folder"],
  },
  {
    name: "Komoto",
    email: "komoto.com",
    location: "jiansd",
    workFields: [],
    employees: [],
    messages: [],
    presentation: "ajsdas",
    images: [],
    phone: "1881412",
    folder: [],
    checkedAttributes: ["name", "email", "presentation"],
  },
  {
    name: "Imlek",
    email: "imlek.com",
    location: "jiansd",
    workFields: [],
    employees: [],
    messages: [],
    presentation: "ajsdas",
    images: [],
    phone: "1881412",
    folder: [],
    checkedAttributes: ["name", "email", "phone"],
  },
  {
    name: "Nis auto",
    email: "nisauto.com",
    location: "jiansd",
    workFields: [],
    employees: [],
    messages: [],
    presentation: "ajsdas",
    images: [],
    phone: "1881412",
    folder: [],
    checkedAttributes: ["name", "email", "phone"],
  },
  {
    name: "Fazi",
    email: "fazi.com",
    location: "jiansd",
    workFields: [],
    employees: [],
    messages: [],
    presentation: "ajsdas",
    images: [],
    phone: "1881412",
    folder: [],
    checkedAttributes: ["name", "email", "employees"],
  },
];

const Promotions = () => {
  const [companies, setCompanies] = useState(firms);
  const [currentCompany, setCurrentCompany] = useState(null);

  let fullCompanyProperties = Object.keys(companies[0]);
  const companyProperties = fullCompanyProperties.filter(
    (item) => item !== "checkedAttributes"
  );

  const handleClickCompany = (company) => {
    if (currentCompany?.name === company.name) setCurrentCompany(null);
    else setCurrentCompany(company);
  };

  const handleClickProperty = (property) => {
    let newCheckedAttributes = [];
    let newCompany;
    if (!currentCompany.checkedAttributes.includes(property)) {
      newCheckedAttributes = [...currentCompany.checkedAttributes, property];
      newCompany = {
        ...currentCompany,
        checkedAttributes: newCheckedAttributes,
      };
    } else {
      newCheckedAttributes = currentCompany.checkedAttributes.filter(
        (attribute) => attribute !== property
      );
      newCompany = {
        ...currentCompany,
        checkedAttributes: newCheckedAttributes,
      };
    }
    setCurrentCompany(newCompany);
    companies.map((company) => {
      if (company.name === currentCompany.name) {
        company.checkedAttributes = newCheckedAttributes;
      }
      return company;
    });
  };

  const checkProperty = (property) => {
    return currentCompany.checkedAttributes.includes(property);
  };

  return (
    <div className="promotions">
      <ul className="promotions-left">
        {companies.map((company, i) => {
          return (
            <div className="promotions-left-item-wrapper" key={i}>
              <li
                className="promotions-left-item"
                key={i}
                onClick={() => handleClickCompany(company)}
              >
                <span className="promotions-left-item-icon">
                  {currentCompany?.name !== company.name ? "+" : "-"}
                </span>
                <span className="promotions-left-item-name">
                  {company.name}
                </span>
              </li>
              {currentCompany?.name === company.name && (
                <div className="promotions-left-list">
                  {companyProperties.map((property, index) => {
                    return (
                      <div className="promotions-left-list-item" key={index}>
                        <span>{property}</span>
                        <input
                          name={index}
                          type="checkbox"
                          checked={checkProperty(property)}
                          onChange={() => handleClickProperty(property)}
                        />
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
      </ul>

      {
        <div className="promotions-right">
          <PromoView
            currentCompany={currentCompany}
            setCurrentCompany={setCurrentCompany}
            companies={companies}
            setCompanies={setCompanies}
          />
        </div>
      }
    </div>
  );
};

export default Promotions;
